import { search } from '@jmespath-community/jmespath';
import jmespath from 'jmespath';

/**
 * Transforms a user-facing JMESPath query with custom syntax into a valid JMESPath expression and executes it.
 *
 * Syntax conversions applied:
 *   "@"    → "@"   (already quoted root key, left as is)
 *   @      → "@"   (literal @ string, not current node)
 *   $this  → @     (current node)
 *   $$   → $     (JMESPath variable prefix)
 *   $      → ''    (strip remaining bare dollar signs)
 */
export const searchJmesPath = (data: any, query: string): any => {
  const cleanQuery = query.trim().replace(/"@"|\$this|\$\$|\$|@/g, match => {
    if (match === '"@"') return match;
    if (match === '$this') return '@';
    if (match === '$$') return '$';
    if (match === '@') return '"@"';
    return ''; // bare $
  });

  if (!cleanQuery) return undefined;

  try {
    return search(data, cleanQuery);
  } catch (error) {
    console.error('[jmespath] search failed:', error, cleanQuery);
    return undefined;
  }
};

/**
 * Evaluates a raw, unmodified JMESPath expression against data and surfaces any error message.
 */
export const evaluateJmesPath = (
  data: any,
  query: string
): { result?: any; error?: string } => {
  const trimmed = query.trim();
  if (!trimmed) return {};

  try {
    return { result: jmespath.search(data, trimmed) };
  } catch (error) {
    return { error: error instanceof Error ? error.message : String(error) };
  }
};
